// 全局配置文件
export const config = {
  // 黑白/彩色切换开关：true表示黑白模式，false表示彩色模式
  enableBlackWhiteMode: 0
}